import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const GET_BASIC_ACCOUNT_REQUEST = 'GET_BASIC_ACCOUNT_REQUEST';
export const GET_BASIC_ACCOUNT_SUCCESS = 'GET_BASIC_ACCOUNT_SUCCESS';
export const GET_BASIC_ACCOUNT_FAILURE = 'GET_BASIC_ACCOUNT_FAILURE';

function request() {
  return {
    type: GET_BASIC_ACCOUNT_REQUEST,
    isGettingBasicAccount: true
  };
}

function receive(basicAccount) {
  return {
    type: GET_BASIC_ACCOUNT_SUCCESS,
    isGettingBasicAccount: false,
    basicAccount
  };
}

function reject() {
  return {
    type: GET_BASIC_ACCOUNT_FAILURE,
    isGettingBasicAccount: false
  };
}

export function getBasicAccount(accountId) {
  return (dispatch) => {
    dispatch(request());

    const promise = () => ApiService
      .getBasicAccount(accountId)
      .then((response) => {
        dispatch(receive(response.data));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, reject));
        }
      });
    return promise();
  };
}
